import * as Yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";
import { isDate, parse } from "date-fns";

import {
  dateofBirthInvalidFormat,
  dateofBirthNineteenInvalidFormat,
  dateofBirthRequired,
  dateRequired,
  emailInvalidFormat,
  emailRequired,
  firstNameRequired,
  lastNameRequired,
  legalAgeRequired,
  oldPasswordRequired,
  passwordMaxLengthText,
  passwordMinLengthText,
  passwordNoMatch,
  passwordRequired,
  phoneInvalidFormat,
  privacyPolicyRequired,
  recaptchaRequired,
} from "./inputErrorMessage";
import { FormattedMessage } from "react-intl";

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function parseDateString(_, originalValue) {
  return isDate(originalValue)
    ? originalValue
    : parse(originalValue, "yyyy-MM-dd", new Date());
}

export const yupKeepInTouch = Yup.object().shape({
  firstName: Yup.string().required(firstNameRequired),
  lastName: Yup.string().required(lastNameRequired),
  emailAddress: Yup.string()
    .required(emailRequired)
    .matches(EMAIL_REGEX, { message: emailInvalidFormat }),
  phoneNumber: Yup.string().test(
    "isValidPhoneNumber",
    phoneInvalidFormat,
    function (value) {
      if (!value) {
        return true;
      }
      return isValidPhoneNumber(value);
    },
  ),
  dateOfBirth: Yup.date()
    .required(dateofBirthRequired)
    .transform(parseDateString)
    .max(
      new Date(new Date().setFullYear(new Date().getFullYear() - 19)),
      dateofBirthNineteenInvalidFormat,
    )
    .min(
      new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
      dateofBirthInvalidFormat,
    ),
  agreeToTerms: Yup.bool()
    .oneOf([true], privacyPolicyRequired)
    .required(privacyPolicyRequired),
  legalAge: Yup.bool()
    .oneOf([true], legalAgeRequired)
    .required(legalAgeRequired),
  recaptcha: Yup.bool()
    .oneOf([true], recaptchaRequired)
    .required(recaptchaRequired),
  preferredLanguage: Yup.string().required(
    <FormattedMessage id="lang-preferred-language-required" />,
  ),
});

export const yupBooking = Yup.object().shape({
  startdate: Yup.string().required(dateRequired),
});

export const yupChangePasswordProfile = Yup.object().shape({
  old_password: Yup.string().required(oldPasswordRequired),
  password: Yup.string()
    .required(passwordRequired)
    .min(8, passwordMinLengthText)
    .max(50, passwordMaxLengthText),
  confirm_pw: Yup.string()
    .required(passwordRequired)
    .oneOf([Yup.ref("password")], passwordNoMatch),
});
